import React from 'react';

import { MyFundsRequests } from 'features/funds-request';

export const MerchantActiveFundsRequests: React.FC = () => (
  <MyFundsRequests active />
);
